<!-- Template from page -->
<template>
  <section class="height-top">
    <div class="col-md-12 height-top padding-null signinv2">

      <div class="content-info">
        <h1>{{$t("Mais facilidade na sua vida!")}}</h1>
        <p class="text-info1">
          {{$t("Nós facilitamos o seu ponto e seus benefícios para")}}<br> {{ $t("você focar no que realmente") }} <strong>{{$t("importa!")}}</strong>
        </p>
        <div class="img1">
          <img src="../../../../assets/img/login/login-group1.png" class="img-responsive apple" alt="icon"/>
        </div>

        <p class="text-info2">{{$t("O aplicativo MarQHR está disponível para Android e iOS")}}</p>

        <div class="stores">
          <a class="nunito" href="https://play.google.com/store/apps/details?id=br.com.marqponto" target="_blank">
            <img src="../../../../assets/img/login/android1.png" class="img-responsive gplay" alt="icon"/>
          </a>
          <a class="nunito" href="https://apps.apple.com/br/app/marqponto/id1379890385" target="_blank">
            <img src="../../../../assets/img/login/apple1.png" class="img-responsive apple" alt="icon"/>
          </a>
        </div>
      </div>

      <div class="col-md-4 height-top form-login right-content">
        <div class="box-login">
          <div class="content-login">
            <img src="../../../../assets/img/login/new-logo-login.png" class="img-responsive logo" alt="Logo" />

            <p class="nunito type"> {{$t("Colaborador")}}</p>

            <h2 v-if="showLogin" class="certa">{{$t("Login")}}</h2>
            <h3 v-else class="certa">{{$t("Informe o seu e-mail para recuperar sua senha")}}</h3>

            <form v-if="showLogin" @submit.prevent="login">
              <div class="form-input">
                <valid-field :v="$v.email" :b-invalid="false" :b-success="false">
                  <div class="group-icon">
                    <img src="../../../../assets/img/login/user.png" class="img-responsive icon-img" alt="usuário" />
                    <input v-model="email" @blur="$v.email.$touch()" type="text" name="email" :placeholder="$t('E-mail/CPF')" required autocomplete="off" />
                  </div>
                </valid-field>
              </div>

              <div class="form-input">
                <valid-field :v="$v.password" :b-invalid="false" :b-success="false">
                  <div class="group-icon">
                    <img src="../../../../assets/img/login/lock.png" class="img-responsive icon-img" alt="usuário" />
                    <input v-model="password" @blur="$v.password.$touch()" type="password" name="password" :placeholder="$t('Password')" required autocomplete="off" />
                  </div>
                </valid-field>
              </div>
              <div class="lost-password">
                <a @click="changeView()" class="nunito">{{$t("Esqueci minha senha")}}</a>
              </div>

              <VueRecaptcha v-if="showCaptcha" id="showCaptca" :sitekey="capthaPublicKey" :loadRecaptchaScript="true" @verify="validate" class="captcha-config"/>

              <div class="content-btn">
                <span class="span"></span><span class="span2"></span>
                <button type="submit" :disabled="loading" v-bind:class="{'disable': loading}" class="certa">
                  <div v-if="loading" class="loading-btn-login">
                    <div class="spinner-btn-login">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>
                  <span v-else>{{$t("Entrar")}}</span>
                </button>
              </div>
            </form>
            <form v-else @submit.prevent="lost">
              <div class="form-input">
                <valid-field :v="$v.emailRecovery" :b-invalid="false" :b-success="false">
                  <div class="group-icon">
                    <img src="../../../../assets/img/login/user.png" class="img-responsive icon-img" alt="usuário" />
                    <input v-model="emailRecovery" @blur="$v.emailRecovery.$touch()" type="email" name="email" :placeholder="$t('E-mail')" required autocomplete="off" />
                  </div>
                </valid-field>
              </div>

              <div class="lost-password">
                <a @click="changeView()" class="nunito">{{$t("Eu sei minha senha")}}</a>
              </div>

              <div class="content-btn">
                <span class="span"></span><span class="span2"></span>
                <button type="submit" :disabled="loadingRecovery" v-bind:class="{'disable': loadingRecovery }">
                  <div v-if="loadingRecovery" class="loading-btn-login">
                    <div class="spinner-btn-login">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>
                  <span v-else>{{$t("Recuperar")}}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<!-- Script from page -->
<script>
import { LOGIN, USER_ME, FORGOT_PASS, WHO_MUCH_FAIL, IS_DEBUG, SECURITY_CROSS, CHECK_TERMS_OF_USE } from "../../../../urlConfig";
import { REQUEST_SERVICE } from "../../../../requestConfig";
import { UTIL_SERVICE } from "../../../../utils";
import { required, email, minLength } from 'vuelidate/lib/validators'
import validField from "../../components/validField";
import swal from 'sweetalert';
import VueRecaptcha from 'vue-recaptcha'
import { languageService } from "../../../../service/languageService";
import { initLocale } from "../../../../service/setLocaleGlobally";
import axios from 'axios';
import md5 from 'md5';

export default {
  name: 'login',
  components: {
    validField,
    VueRecaptcha
  },
  computed: {

  },
  data() {
    return {
      isLoginByEmail: true,
      showCaptcha: false,
      validCaptcha: false,
      capthaPublicKey: '6LcvAeobAAAAAJy2G5tUF3a2g-qvCXqcgfWxKpuO',
      countFailLogin: 0,
      msg: 'Colaborador',
      loading: false,
      loadingRecovery: false,
      showLogin: true,
      email: '',
      password: '',
      emailRecovery: '',
      browserId: '',
    }
  },
  validations: {
    email: {
      required,
    },
    emailRecovery: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(4)
    }
  },
  methods: {
    validate (response) {
      this.validCaptcha = true;
    },
    whoFailLogin() {
      REQUEST_SERVICE.get(WHO_MUCH_FAIL + "?username=" + this.email +"&device=web-register").then((response) => {
        UTIL_SERVICE.console("RESULT WHO_MUCH_FAIL:", response);
      });
    },
    async me(){
      try {
      const response = await REQUEST_SERVICE.get(USER_ME);
      
      if (response.status === 200) {
        window.localStorage.setItem('userInfo', JSON.stringify(response.data));
        this.loading = true;

        
        if (response.data.company.locale !== null) {
          await languageService.setLanguage(response.data.company.locale);
          await initLocale.change(response.data.company.locale)
        }
        
        UTIL_SERVICE.historyLog(false, window.location.pathname, 'me', {}, false, null);
        
        this.$router.push({ path: '/' });
      }
      } catch (reason) {
        window.localStorage.removeItem("authUser");
        UTIL_SERVICE.historyLog(false, window.location.pathname, 'me', {}, true, reason.response.data);
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
        this.loading = false;
      }

      const t = JSON.parse(localStorage.getItem('authUser')).token
      await this.crossToken(t);
    },
    login() {
      if (this.showCaptcha === false) {
        if (this.$v.email.$invalid || this.$v.password.$invalid) {
          this.$v.$touch();
        } else {
          this.loading = true;

          if (this.email.includes("@")) {
            this.isLoginByEmail = true;
          } else {
            this.isLoginByEmail = false;
            this.email = this.email.replace(/[^0-9]/g, '');
          }

          REQUEST_SERVICE.login(LOGIN, { password: this.password, email: this.email }, this.browserId).then(async (response) => {
            if (response.status === 200) {
              let authUser = {};

              authUser.isAuth = true;
              authUser.userToken = response.data.access_token;
              authUser.userTokenType = response.data.token_type;
              authUser.userContentSetting = response.data.contentsetting;
              authUser.token = response.data.token;

              window.localStorage.setItem('authUser', JSON.stringify(authUser));
              UTIL_SERVICE.historyLog(false, window.location.pathname, 'login', this.email, false, null);

              this.me(authUser);
            }
          })
            .catch((reason) => {
              window.localStorage.removeItem("authUser");
              UTIL_SERVICE.historyLog(false, window.location.pathname, 'login', this.email, true, reason.response.data);
              this.countFailLogin++;
              if (this.countFailLogin >= 3) {
                this.showCaptcha = true;
              }
              if (this.countFailLogin >= 8) {
                this.countFailLogin = 0;
                this.whoFailLogin();
              }

              try {
                if (reason.response.data.error_description === 'Usuário não encontrado no sistema.' || reason.response.data.error_description === 'Usuário não encontrado.') {
                  if (this.isLoginByEmail) {
                    swal(this.$t("Aviso"), this.$t("Usuário não encontrado no sistema.\nSe estiver tentando logar com seu e-mail, revise os dados e tente novamente.\nSe preferir, você também pode logar usando seu CPF."), "error");
                  } else {
                    swal(this.$t("Aviso"), this.$t("Usuário não encontrado no sistema.\nSe estiver tentando logar com CPF, revise os dados e tente novamente.\nVocê também pode logar usando seu e-mail."), "error");
                  }
                } else {
                  swal(this.$t("Aviso"), this.$t(reason.response.data.error_description), "error");
                }
              } catch (e) {
                swal(this.$t("Aviso"), this.$t(reason.response.data.error_description), "error");
              }

              this.loading = false;
            });
            
        }
      } else if (this.validCaptcha) {
        if (this.$v.email.$invalid || this.$v.password.$invalid) {
          this.$v.$touch();
        } else {
          this.loading = true;

          if (this.email.includes("@")) {
            this.isLoginByEmail = true;
          } else {
            this.isLoginByEmail = false;
            this.email = this.email.replace(/[^0-9]/g, '');
          }

          REQUEST_SERVICE.login(LOGIN, { password: this.password, email: this.email }, this.browserId).then((response) => {
            if (response.status === 200) {
              let authUser = {};

              authUser.isAuth = true;
              authUser.userToken = response.data.access_token;
              authUser.userTokenType = response.data.token_type;
              authUser.userContentSetting = response.data.contentsetting;
              authUser.token = response.data.token;

              
              window.localStorage.setItem('authUser', JSON.stringify(authUser));
              this.me();
              UTIL_SERVICE.historyLog(false, window.location.pathname, 'login', this.email, false, null);

            }
          })
            .catch((reason) => {
              UTIL_SERVICE.historyLog(false, window.location.pathname, 'login', this.email, true, reason.response.data);
              this.countFailLogin++;
              if (this.countFailLogin >= 8) {
                this.countFailLogin = 0;
                this.whoFailLogin();
              }

              try {
                if (reason.response.data.error_description === 'Usuário não encontrado no sistema.' || reason.response.data.error_description === 'Usuário não encontrado.') {
                  if (this.isLoginByEmail) {
                    swal(this.$t("Aviso"), this.$t("Usuário não encontrado no sistema.\nSe estiver tentando logar com seu e-mail, revise os dados e tente novamente.\nSe preferir, você também pode logar usando seu CPF."), "error");
                  } else {
                    swal(this.$t("Aviso"), this.$t("Usuário não encontrado no sistema.\nSe estiver tentando logar com CPF, revise os dados e tente novamente.\nVocê também pode logar usando seu e-mail."), "error");
                  }
                } else {
                  swal(this.$t("Aviso"), this.$t(reason.response.data.error_description), "error");
                }
              } catch (e) {
                swal(this.$t("Aviso"), this.$t(reason.response.data.error_description), "error");
              }

              this.loading = false;
            });
        }
      } else {
        swal(this.$t("Aviso"), this.$t('Você precisa preencher o Captcha para fazer login no sistema.'), "error");
      }
    },
    lost() {
      if (this.$v.emailRecovery.$invalid) {
        this.$v.$touch();
      } else {
        this.loadingRecovery = true;
        REQUEST_SERVICE.get(FORGOT_PASS + "?email=" + this.emailRecovery)
          .then((response) => {
            swal(this.$t("Sucesso!"), this.$t(response.data), "success");

            UTIL_SERVICE.historyLog(false, window.location.pathname, 'lost', this.emailRecovery, false, null);

            this.loadingRecovery = false;
            this.showLogin = true;
          }).catch(reason => {
            this.loadingRecovery = false;

            UTIL_SERVICE.historyLog(false, window.location.pathname, 'lost', this.emailRecovery, true, reason.response.data);

            reason.response.data.erros.map((value, index) => {
              swal(this.$t("Aviso"), this.$t(value.value), "error");
            });
          });
      }
    },
    changeView() {
      this.showLogin = !this.showLogin;
    },
    checkShowCaptcha() {
      if (IS_DEBUG) {
        setTimeout(() => {
          const element = document.getElementById("showCaptca");
          element.parentNode.removeChild(element);
          this.showCaptcha = false;
        }, 1000);
      } else {
        REQUEST_SERVICE.get('https://marqponto-report.azurewebsites.net/ip').then((response) => {
          if (response.data) {
            const element = document.getElementById("showCaptca");
            element.parentNode.removeChild(element);
            this.showCaptcha = false;
          }
        });
      }
    },
    async crossToken(token) {
      const url = `${SECURITY_CROSS}/${this.getHash(token)}`;

      try {
        const response = await axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            _tId: token,
          },
          timeout: 180000,
        });

        const authUser = JSON.parse(localStorage.getItem('authUser'));
        authUser.v2Token = response.data.token;
        localStorage.setItem('authUser', JSON.stringify(authUser))
       } catch (error) {
      }
    },
    getHash(cross) {
      //mover hash para env
      const s = '_6894bf30';
      const date = new Date();
      const year = date.getUTCFullYear();
      const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
      const day = date.getUTCDate().toString().padStart(2, '0');
      const hour = date.getUTCHours().toString().padStart(2, '0');
      const hash = `${cross}.${year}${month}${day}${hour}.${s}`;
      const newHash = md5(hash);
      return newHash;
  },
  },
  beforeMount(){
    this.checkShowCaptcha();

    UTIL_SERVICE.historyLog(true);

    // Set theme default
    const darkMode = JSON.parse(window.localStorage.getItem('darkMode'));
    if(!darkMode) {
      window.localStorage.setItem('darkMode', JSON.stringify({dark: false}));
    }

    // Set menu open on login
    window.localStorage.setItem('showMenuOpen', JSON.stringify({show: true}));

    // Set BrowserID
    this.browserId = JSON.parse(window.localStorage.getItem('browserId'));

    // Hidden footer
    try {
      $("#vueFooter").addClass("d-none");
    } catch(e){}

    if (this.browserId === null) {
      this.browserId = UTIL_SERVICE.randomToken();
      window.localStorage.setItem('browserId', JSON.stringify(this.browserId));
    }
  },
}
</script>
<style lang="scss">
.signinv2 .content-info .stores a .gplay {
  left: 120px;
}

.signinv2 .content-info .stores a .apple {
  top: -3px;
  left: -4px;
}

.captcha-config {
  margin-top: 20px;
  width: 100%;
  display: block;

  div {
    display: block;
    margin: 0 0 0 auto;
  }
}

.signinv2 {
  background-image: none;

  .content-info {
    background: rgb(51,51,153);
    background: linear-gradient(180deg, rgba(51,51,153,1) 40%, rgba(31,31,119,1) 70%);
    width: 67%;
    height: 100%;
    .img1 {
      img {
        margin: -40px auto -10px auto !important;
      }
    }
  }

  .text-info1 {
    padding: 0 17% !important;

    strong {
      color: #FFFFFF !important;
    }
  }

  .text-info2 {
    font-size: 1.5rem !important;
    font-weight: 400 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/views/public/login/Login.vue